export default __webpack_public_path__ + "static/media/linux.139bbf86.svg";